import apiSheetService from '@/services/api/ambassador/sheetService';

export default {
  async getTypes(context) {
    if (!context.state.types) {
      const types = await apiSheetService.getTypes();
      context.commit('setTypes', types);
    }
  },
};
